
export const NotFound = () => {
    return (<div className="container-fluid">
        <div className="row text-center">
            <div className="col-12">
                <h4>OOOPS! 404</h4>
            </div>
            <div className="col-12">
                <p className="text-justify">Página não encontrada...</p>
            </div>
        </div>
    </div>);
}